import React from "react";
import { CLIENT_PREFIX_PATH } from "constants/route.constant";
import { CLIENT, FREELANCER } from "constants/roles.constant";

const clientAccountRoute = [
  //manage cms  route
  {
    key: "account.settings",
    path: `${CLIENT_PREFIX_PATH}/account/settings`,
    component: React.lazy(() => import("views/account/settings")),
    authority: [CLIENT, FREELANCER],
  },
  {
    key: "account.profile",
    path: `${CLIENT_PREFIX_PATH}/account/profile`,
    component: React.lazy(() => import("views/account/profile")),
    authority: [CLIENT, FREELANCER],
  },
];
export default clientAccountRoute;
